var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{staticClass:"responsibility-swiper",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.imgList),function(item,idx){return _c('swiper-slide',{key:idx,staticClass:"responsibility-swiper-item"},[_c('img',{attrs:{"src":item.url}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }